/**
 * Copyright © 2026 Delicious AI, LLC
 *
 * FirebaseUI sign-in widget. Avoids react-firebaseui's StyledFirebaseAuth, which
 * calls AuthUI.delete() on unmount and breaks under React 18 Strict Mode.
 */

import 'firebaseui/dist/firebaseui.css'

import { auth as firebaseAuth, uiConfig } from 'api/Firebase'
import { auth as firebaseUiAuth } from 'firebaseui'
import { useEffect, useRef } from 'react'

import FirebaseUiThemeStyles from '@/components/auth/FirebaseUiThemeStyles'

const FirebaseAuthWidget = ({ className }: { className?: string }) => {
  const containerRef = useRef<HTMLDivElement>(null)

  useEffect(() => {
    const element = containerRef.current
    if (!element) return

    const ui =
      firebaseUiAuth.AuthUI.getInstance() ??
      new firebaseUiAuth.AuthUI(firebaseAuth)

    ui.start(element, uiConfig)

    return () => {
      ui.reset()
    }
  }, [])

  return (
    <>
      <FirebaseUiThemeStyles />
      <div className={className} ref={containerRef} />
    </>
  )
}

export default FirebaseAuthWidget
